import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
// import userPlaceholder from "../../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { useHistory } from "react-router-dom";

const Show = ({ match }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const {
		params: { id },
	} = match;
	const metaTypeList = [
		{ name: "الرئيسية", value: "home" },
		{ name: "من نحن", value: "about" },
		{ name: "خدماتنا", value: "services" },
		{ name: "الباقات", value: "packages" },
		{ name: "معرض الأعمال", value: "projects" },
		{ name: "المدونة", value: "blog" },
		{ name: "اتصل بنا", value: "contact" },
		{ name: "الباقات", value: "packages" },
		{ name: "سياسة الموقع", value: "privacy" },
		{ name: "خريطة الموقع", value: "sitemap" },
		{ name: "الشروط والأحكام", value: "terms" },
	];

	const [loading, setLoading] = useState(true);
	const [metaNameAr, setMetaNameAr] = useState("");
	const [metaNameEn, setMetaNameEn] = useState("");
	const [metaContentAr, setMetaContentAr] = useState("");
	const [metaContentEn, setMetaContentEn] = useState("");
	const [metaType, setMetaType] = useState("");

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل السيو",
				breadcrumb: "السيو",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/metadataTags/${id}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setLoading(false);
				setMetaNameAr(response.data.data.name.ar);
				setMetaNameEn(response.data.data.name.en);
				setMetaContentAr(response.data.data.content.ar);
				setMetaContentEn(response.data.data.content.en);
				setMetaType(response.data.data.type);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (
			!metaNameAr ||
			!metaNameEn ||
			!metaContentAr ||
			!metaContentEn ||
			!metaType
		) {
			return toast.error("جميع البيانات مطلوبة");
		}

		setLoading(true);
		const data = {
			name: {
				ar: metaNameAr,
				en: metaNameEn,
			},
			content: {
				ar: metaContentAr,
				en: metaContentEn,
			},
			type: metaType,
		};
		axios
			.put(`${process.env.REACT_APP_API_URL}/metadataTags/${id}`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				history.push("/seo/index");

				toast.success("تم تحديث البيانات بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div
					className="card"
					style={{
						padding: "30px 30px 0",
					}}
				>
					<div className="row">
						<div className="form-item col-md-6">
							<label>عنوان الميتا ( عربي )</label>
							<input
								type="text"
								value={metaNameAr}
								onChange={e => setMetaNameAr(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>عنوان الميتا ( انجليزي )</label>
							<input
								type="text"
								value={metaNameEn}
								onChange={e => setMetaNameEn(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>وصف الميتا ( عربي )</label>
							<input
								type="text"
								value={metaContentAr}
								onChange={e => setMetaContentAr(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>وصف الميتا ( انجليزي )</label>
							<input
								type="text"
								value={metaContentEn}
								onChange={e => setMetaContentEn(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-12">
							<label>نوع الميتا</label>
							<select
								value={metaType}
								onChange={e => setMetaType(e.target.value)}
							>
								<option value={""}>{"اختر نوع الميتا"}</option>
								{metaTypeList?.map((item, index) => (
									<option key={index} value={item.value}>
										{item.name}
									</option>
								))}
							</select>
						</div>
						<div className="col-md-12">
							<div className="form-item  ">
								<button className="bt bt-success btn-block">ارسال</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default Show;
